// Etapas de un pedido del catálogo (sql/121) y los mensajes de WhatsApp de
// cada paso. La clienta ve la etapa en el enlace de su pedido (/pd/<grupo>).
import { metodoPago } from './tiendaPago';

export const ETAPAS = {
  recibido: { etiqueta: 'Recibido', icono: '📥' },
  confirmado: { etiqueta: 'Confirmado', icono: '✅' },
  pagado: { etiqueta: 'Pagado', icono: '💳' },
  enviado: { etiqueta: 'Enviado', icono: '🚚' },
  listo: { etiqueta: 'Listo para recoger', icono: '🏬' },
  entregado: { etiqueta: 'Entregado', icono: '📦' },
  cancelado: { etiqueta: 'Cancelado', icono: '✖️' },
};

// Los pasos según cómo lo recibe: a domicilio se "envía"; en tienda queda "listo".
export const pasosPara = (entrega) => ['recibido', 'confirmado', 'pagado', entrega === 'tienda' ? 'listo' : 'enviado', 'entregado'];

export const etapaDe = (p) => (p && ETAPAS[p.etapa] ? p.etapa : 'recibido');

// El paso que sigue después de pagado (lo que la dueña marca desde el Historial).
export function siguienteEtapa(p) {
  const e = etapaDe(p);
  if (e === 'pagado') return p.entrega === 'tienda' ? 'listo' : 'enviado';
  if (e === 'enviado' || e === 'listo') return 'entregado';
  return null;
}

// Texto de "cómo pagar" por defecto si la tienda no ha guardado el suyo.
export function instruccionesPorDefecto(pago) {
  if (pago === 'efectivo') return 'Pagas en efectivo cuando recibas tu pedido.';
  if (pago === 'tarjeta') return 'Pagas con tarjeta en la tienda.';
  if (pago === 'link') return 'Te envío el link de pago por aquí.';
  return '';
}

const dineroCon = (simbolo) => (n) => `${simbolo} ${Number(n || 0).toLocaleString('es-HN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Mensaje de "✅ pedido confirmado": prendas, total y cómo pagar + enlace para seguirlo.
export function mensajeConfirmacion(p, { envio = null, pago = null, instrucciones = '', enlace = '', simbolo = 'L' } = {}) {
  const dinero = dineroCon(simbolo);
  const prendas = p.prendas || [p];
  const subtotal = prendas.reduce((s, x) => s + (x.precio || 0) * (x.cantidad || 1), 0);
  const filas = prendas.map((x) => `▪ ${x.cantidad || 1} × ${x.nombre_producto} (${dinero((x.precio || 0) * (x.cantidad || 1))})`);
  let totales;
  if (p.entrega === 'tienda') totales = `Total: ${dinero(subtotal)}\n🏬 Lo recoges en la tienda.`;
  else if (envio !== null && envio !== undefined && envio !== '') {
    const e = Number(envio) || 0;
    totales = `Subtotal: ${dinero(subtotal)}\nEnvío: ${e > 0 ? dinero(e) : 'gratis 🎉'}\nTotal: ${dinero(subtotal + e)}`;
  } else totales = `Total: ${dinero(subtotal)}${p.entrega === 'domicilio' ? ' + envío' : ''}`;
  const m = metodoPago(pago);
  const comoPagar = m
    ? `\n\n${m.icono} Forma de pago: ${m.nombre}${instrucciones?.trim() ? `\n${instrucciones.trim()}` : ''}`
    : (instrucciones?.trim() ? `\n\n💳 Para pagar:\n${instrucciones.trim()}` : '');
  const comprobante = pago && pago !== 'efectivo' && pago !== 'tarjeta' ? '\n\nCuando pagues, mándame la foto del comprobante por aquí 🙏' : '';
  return `¡Hola ${p.cliente_nombre}! 😊 ✅ Tu pedido está confirmado:\n\n${filas.join('\n')}\n\n${totales}${comoPagar}${comprobante}`
    + (enlace ? `\n\n📦 Sigue tu pedido aquí:\n${enlace}` : '');
}

// Aviso de cada paso siguiente (enviado / listo / entregado).
export function mensajeEtapa(p, etapa, enlace = '') {
  const hola = `¡Hola ${p.cliente_nombre}! 😊`;
  const texto = {
    pagado: `${hola} Recibimos tu pago ✅ Ya estamos preparando tu pedido.`,
    enviado: `${hola} Tu pedido ya va en camino 🚚`,
    listo: `${hola} Tu pedido ya está listo para recoger en la tienda 🏬`,
    entregado: `${hola} Tu pedido fue entregado 📦 ¡Gracias por tu compra! 💕`,
  }[etapa] || `${hola} Tu pedido cambió a: ${ETAPAS[etapa]?.etiqueta || etapa}.`;
  return texto + (enlace && etapa !== 'entregado' ? `\n\nSíguelo aquí:\n${enlace}` : '');
}
